export default __webpack_public_path__ + "static/media/guitar_2.438d8085.png";